import React from "react";
import { withImageResizer } from "lib/utils";
import Link from "next/link";
import CrossIcon from "../Icons/CrossIcon";
import BrickIcon from "../Icons/BrickIcon";
import ChairIcon from "../Icons/ChairIcon";
import PaymentCardIcon from "../Icons/PaymentCardIcon";

const Banner = ({ church }) => {
  const {
    data: { built, material, seats },
    contentHTML,
  } = church?.descriptionParsed;
  return (
    <section
      className="flex justify-center relative mt-[380px] tablet-200:flex-col tablet-200:items-center"
      role="banner"
    >
      <div className="pl-6 tablet-100:pl-2 mt-[-300px] z-[1] phone:pl-0">
        <img
          role="img"
          alt="kirkon pääkuva"
          className="shadow-xl bg-gray-100 rounded-lg max-w-m h-[600px] object-cover desktopSmall:max-w-[300px] desktopSmall:max-h-[500px] tablet-200:max-h-[230px] tablet-200:max-w-[600px] tablet-200:mt-[150px] tablet-200:mb-6 phone-300:max-w-[300px]"
          src={
            church?.images?.card
              ? withImageResizer(church.images.card, 640)
              : "/images/church-icon.png"
          }
        />
        {/*<Link href={`/lahjoita/${church?.account?.slug}`}>
          <a className="rounded-full bg-blue text-white py-4 mx-auto w-40 mt-6 block text-center text-xl flex items-center justify-center">
            <PaymentCardIcon />
            <span className="ml-3">Lahjoita</span>
          </a>
  </Link>*/}
      </div>
      <div className="pl-16 tablet-100:pl-10 pb-0 flex-1 tablet-100:pr-4 tablet-200:px-0">
        <h1 className="text-xlHeader pb-5 laptop:text-lheader laptop:pb-0 phone-200:text-5xl">
          {church?.account?.name}
        </h1>
        <div>
          <div className="flex pb-7 phone-200:flex-col">
            {built && (
              <div className="text-xl font-bold text-gray flex items-center pr-9 desktopSmall:flex-col desktopSmall:text-center desktopSmall:justify-between phone-200:flex-row phone-200:justify-start phone-200:mt-5">
                <CrossIcon height={20} width={13} />
                <span className="pl-1.5 desktopSmall:pl-0 desktopSmall:mt-2 phone-200:mt-0 phone-200:ml-3">
                  Rakennettu {built}
                </span>
              </div>
            )}

            {material && (
              <div className="text-xl font-bold text-gray flex items-center pr-9 desktopSmall:flex-col desktopSmall:text-center desktopSmall:justify-between phone-200:flex-row phone-200:justify-start phone-200:mt-5">
                <BrickIcon height={16} width={18} />
                <span className="pl-1.5 desktopSmall:pl-0 desktopSmall:mt-2 phone-200:mt-0 phone-200:ml-3">
                  Materiaali {material}
                </span>
              </div>
            )}

            {seats && (
              <div className="text-xl font-bold text-gray items-center flex desktopSmall:flex-col desktopSmall:text-center desktopSmall:justify-between phone-200:flex-row phone-200:justify-start phone-200:mt-5">
                <ChairIcon height={20} width={20} />
                <span className="pl-1.5 desktopSmall:pl-0 desktopSmall:mt-2 phone-200:mt-0 phone-200:ml-3">
                  Istumapaikkoja {seats}
                </span>
              </div>
            )}
          </div>
          <div className="text-bodyText pb-6 max-w-x">
            <div
              className="prose prose-xl laptop:text-lg phone-100:text-base"
              dangerouslySetInnerHTML={{ __html: contentHTML }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
